import { alpha } from "@mui/material";

const styles = (theme) => {
  const verde = theme.palette.colors.green.light;
  const primaria = theme.palette.primary.main;

  return {
    card: {
      borderRadius: "16px !important",
      boxShadow: "none",
      border: `1px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.background.paper,
      overflow: "hidden",
      "&:before": { display: "none" },
    },

    summary: {
      px: 2,
      "& .MuiAccordionSummary-content": { my: 1.5, minWidth: 0 },
    },
    summaryContent: {
      display: "flex",
      alignItems: "center",
      gap: 1.5,
      width: "100%",
      minWidth: 0,
    },
    avatar: {
      width: 44,
      height: 44,
      borderRadius: "12px",
      fontSize: "0.85rem",
      fontWeight: "bold",
      bgcolor: alpha(primaria, 0.15),
      color: primaria,
    },
    summaryText: {
      flex: 1,
      minWidth: 0,
    },
    nomeRow: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 1,
    },
    nome: {
      fontSize: "16px",
      fontWeight: 600,
    },
    chipTipo: {
      fontWeight: 700,
      fontSize: "0.7rem",
      letterSpacing: "0.5px",
      bgcolor: alpha(primaria, 0.12),
      color: primaria,
    },
    chipAtivo: {
      fontWeight: 600,
      fontSize: "0.7rem",
      bgcolor: alpha(verde, 0.15),
      color: verde,
      "& .MuiChip-icon": { color: verde },
    },
    chipInativo: {
      fontSize: "0.7rem",
      color: theme.palette.text.secondary,
    },
    descricao: {
      fontSize: "0.8rem",
      color: theme.palette.text.secondary,
      mt: 0.3,
    },
    summaryResumo: {
      display: { xs: "none", sm: "flex" },
      alignItems: "center",
      gap: 1.5,
    },
    resumoItem: {
      display: "flex",
      alignItems: "center",
      gap: 0.5,
      px: 1,
      py: 0.4,
      borderRadius: "8px",
      bgcolor: theme.palette.action.hover,
    },
    resumoIcone: {
      fontSize: "16px",
      color: theme.palette.text.secondary,
    },
    resumoTexto: {
      fontSize: "0.8rem",
      fontWeight: 600,
    },
    summaryActions: {
      display: "flex",
      alignItems: "center",
    },
    details: {
      display: "flex",
      flexDirection: "column",
      gap: 2,
      px: 2,
      pb: 2,
      pt: 2,
      borderTop: `1px solid ${theme.palette.divider}`,
    },
    secao: {
      display: "flex",
      flexDirection: "column",
      gap: 1.5,
      padding: "14px",
      borderRadius: "12px",
      bgcolor:
        theme.palette.mode === "dark"
          ? theme.palette.background.modalContrast
          : theme.palette.background.wallpaper,
    },
    secaoHeader: {
      display: "flex",
      alignItems: "flex-start",
      flexWrap: { xs: "wrap", sm: "nowrap" },
      gap: 1.5,
    },
    secaoIconeBox: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: 34,
      height: 34,
      borderRadius: "10px",
      flexShrink: 0,
      bgcolor: alpha(primaria, 0.12),
    },
    secaoIcone: {
      fontSize: "19px",
      color: primaria,
    },
    secaoTituloRow: {
      display: "flex",
      alignItems: "center",
      gap: 1,
    },
    secaoTitulo: {
      fontWeight: 600,
      fontSize: "0.95rem",
    },
    chipContador: {
      height: 20,
      fontSize: "0.7rem",
      fontWeight: 600,
    },
    secaoDescricao: {
      fontSize: "0.75rem",
      color: theme.palette.text.secondary,
    },
    vazio: {
      display: "flex",
      flexDirection: "column",
      gap: 0.5,
      padding: "18px",
      borderRadius: "12px",
      border: `1px dashed ${theme.palette.divider}`,
      textAlign: "center",
    },
    vazioTexto: {
      fontSize: "0.85rem",
      fontWeight: 600,
      color: theme.palette.text.secondary,
    },
    vazioEnv: {
      fontSize: "0.75rem",
      color: theme.palette.text.secondary,
      fontFamily: "monospace",
      wordBreak: "break-word",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
      gap: 1.5,
    },

    // --- Card de conexão ---
    conexao: {
      display: "flex",
      flexDirection: "column",
      gap: 1.2,
      padding: "12px 14px",
      borderRadius: "12px",
      backgroundColor: theme.palette.background.paper,
    },
    conexaoEmUso: {
      borderColor: alpha(verde, 0.7),
    },
    conexaoHeader: {
      display: "flex",
      alignItems: "center",
      gap: 1,
      minWidth: 0,
    },
    posicao: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minWidth: 28,
      height: 24,
      px: 0.5,
      borderRadius: "6px",
      fontSize: "0.72rem",
      fontWeight: 700,
      bgcolor: theme.palette.action.selected,
    },
    conexaoNome: {
      fontWeight: 600,
      fontSize: "0.9rem",
      minWidth: 0,
    },
    chipEmUso: {
      height: 22,
      fontWeight: 600,
      fontSize: "0.7rem",
      bgcolor: alpha(verde, 0.15),
      color: verde,
      "& .MuiChip-icon": { color: verde, fontSize: "14px" },
    },
    conexaoAlerta: {
      borderRadius: "10px",
      fontSize: "0.75rem",
      py: 0,
    },
    campos: {
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      gap: "10px 16px",
    },
    campo: {
      minWidth: 0,
    },
    campoLargo: {
      minWidth: 0,
      gridColumn: "1 / -1",
    },
    campoLabel: {
      fontSize: "0.7rem",
      color: theme.palette.text.secondary,
      textTransform: "uppercase",
      letterSpacing: "0.4px",
    },
    campoValor: {
      fontSize: "0.82rem",
      fontFamily: "monospace",
    },
    campoSecreto: {
      display: "flex",
      alignItems: "center",
      gap: 0.5,
      fontSize: "0.82rem",
      fontFamily: "monospace",
    },
    cadeado: {
      fontSize: "14px",
      color: theme.palette.text.secondary,
    },
    campoVazio: {
      fontSize: "0.8rem",
      fontStyle: "italic",
      color: theme.palette.text.disabled,
    },
    conexaoRodape: {
      fontSize: "0.7rem",
      color: theme.palette.text.secondary,
      pt: 1,
      borderTop: `1px solid ${theme.palette.divider}`,
    },
  };
};

export default styles;
